import React from "react";
import { Link } from "react-router-dom";
import { solutions } from "@/content/site";
import { PageHero, CtaBand } from "@/components/NovaKit";

export default function Solutions() {
  const g = solutions.gateway;
  return (
    <div data-testid="solutions-page">
      <PageHero eyebrow={g.eyebrow} heading={g.heading} highlight="how organisations actually operate" intro={g.intro} index="05" />
      <section className="border-t hairline panel">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-14 py-20 md:py-24">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {g.cards.map((c, i) => (
              <Link to={c.to} key={c.title}
                className="grad-border card-hover bg-white rounded-[20px] border hairline p-10 md:p-14 group min-h-[320px] flex flex-col justify-between" data-testid={`solutions-gateway-${i}`}>
                <div>
                  <div className="flex items-baseline justify-between mb-10">
                    <span className="mono text-[11px] uppercase tracking-[0.2em] font-bold grad-text">05.{i + 1}</span>
                    <span className="w-12 h-12 rounded-full grad-bg text-white inline-flex items-center justify-center text-base group-hover:scale-110 transition-transform">→</span>
                  </div>
                  <h2 className="display text-3xl md:text-4xl font-bold leading-tight mb-4">{c.title}</h2>
                  <p className="text-sm md:text-base leading-relaxed text-[#0A0E1A]/70">{c.body}</p>
                </div>
                <div className="mt-10 mono text-[11px] uppercase tracking-[0.2em] text-[#4F46E5] font-semibold">Explore pathway →</div>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <CtaBand heading="Not every organisation needs the same path." body={solutions.bottomCta.body} ctas={solutions.bottomCta.ctas} />
    </div>
  );
}
